import { createReducer } from '../../common/reduxHelpers'
import * as types from './actionTypes';

const reducer = createReducer({}, {
    [types.UPDATE](state, action) {
        return action.user;
    }
});

export default reducer;